import { render, staticRenderFns } from "./UserByCallBase.vue?vue&type=template&id=0b9c43a8&scoped=true&"
import script from "./UserByCallBase.vue?vue&type=script&lang=js&"
export * from "./UserByCallBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c43a8",
  null
  
)

export default component.exports